import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "v-time"
}

import dayjs from 'dayjs';
import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'VTime',
  props: {
    date: null
  },
  setup(__props: any) {

const props = __props as { date?: number | string | null | undefined }


const text = computed(() => {
  if (!props.date) return ""
  return dayjs(props.date).format("DD.MM.YY")
})


return (_ctx: any,_cache: any) => {
  return (_unref(text))
    ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(_unref(text)), 1))
    : _createCommentVNode("", true)
}
}

})